import React, { Component } from 'react';
import Select from 'react-select';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { CustomCard } from "../../components/Card/CustomCard";
import CustomModal from "../../components/Modal/CustomModal";

import logo from "../../assets/img/logo-TAD-d.png";
import { Url } from '../../shared/Url';
import Post from '../../shared/Post';

import TiempoRestante from '../Componentes/TiempoRestante';

let statusBtn = 0;
let fechaRestante = "Mar 09 2020 00:00:00 GMT-4";

class Register extends Component {
    state = {
        title: "¿Qué es esto?",
        selectedOption: {
            value: '1',
            label: 'Estudiante'
        },
        button: {
            Icon:"pe-7s-add-user",
            Title:"Registrarme",
            disabled: false
        },
        user:{
            text: "",
            status: ""
        },
        pass1:{
            text: "",
            status: ""
        },
        pass2:{
            text: "",
            status: ""
        },
        tituloModal:"",
        contenidoModal:"",
        boton1Modal:"",
        boton2Modal:"",
        openW: false,
        time: "",
    }

    funcion1 = () => {

    }

    botones = () => {

        const { button } = this.state;

        switch (statusBtn) {
            case 0:
                return (
                    <button className="btn btn-primary fuente-monserrat" id="register" onClick={this.register()} disabled={button.disabled} style={{borderWidth:1}}><i className= {button.Icon} style={{fontSize:16}}></i> {button.Title}</button>
                )
            case 1:
                let proximamente = (
                    <Popover title="Importante" id="pass" className="fuente-monserrat">
                        <div align="center">El Sistema se encuentra en mantenimiento.</div>
                        <TiempoRestante fechaFinal = {fechaRestante}/>
                    </Popover>
                )

                return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={proximamente}>
                        <button className="btn btn-primary fuente-monserrat" id="register" style={{borderWidth:1}}><i className= {button.Icon} style={{fontSize:16}}></i> {button.Title}</button>
                    </OverlayTrigger>
                )
            default:
                return (<div></div>)
        } 
    }

    handleChange = (selectedOption) => {
        this.setState({
            selectedOption,
            openW: false
        });
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:event.target.value,
                status: ""
            },
            openW: false
        });
    };

    cambiaValorEmail = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:event.target.value.toLowerCase(),
                status: ""
            },
            openW: false
        });
    };

    register = () => (e) => {
        let { user, pass1, pass2, selectedOption } = this.state;
        let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;

        if(user.text === ""){toast.error(<div className="fuente-monserrat">El campo Correo Electrónico no debe estar vacío</div>,{});return null}
        if(expReg.test(user.text) === false){
            this.setState ({
                user: {status: "has-error"}
            },() => {
                toast.error(<div className="fuente-monserrat">El campo Correo Electrónico debe tener un formato válido</div>,{});
            });
            return null;
        }
        if(pass1.text === ""){
            this.setState ({
                pass1: {status: "has-error"}
            },() => {
                toast.error(<div className="fuente-monserrat">El campo Contraseña es obligatorio</div>,{});
            });
            return null;
        }
        if(pass1.text !== pass2.text){
            this.setState ({
                pass1: {status: "has-error"},
                pass2: {status: "has-error"}
            },() => {
                toast.error(<div className="fuente-monserrat">Las contraseñas no coinciden</div>,{});
            });
            return null;
        }

        this.setState ({
            button: {
                Icon:"fa fa-spinner fa-spin",
                Title:"Verificando espere...",
                disabled: true
            }
        },() => {
            this.procesarRegistro (user.text, pass2.text, selectedOption.value)
        });
    }

    procesarRegistro = (user, pass, utype) => {
        let Content = {
            User: user,
            Pass: pass,
            UType: utype
        }
        Post(`${Url}registerUser`, Content, (resp) => {
            let data = JSON.parse(resp);
            if (data.status === "1"){
                this.setState ({
                    openW: true,
                    tituloModal:
                        <div className="titulo-modal">
                            <span style={{color:"#2e6da4"}} className="fuente-monserrat"><i className="pe-7s-info"></i></span> {data.titulo}
                        </div>,
                    contenidoModal: data.mensaje,
                    boton1Modal: "",
                    boton2Modal: "Aceptar",
                    button: {
                        Icon:"pe-7s-add-user",
                        Title:"Registrarme",
                        disabled: false
                    },
                },() => {
                    this.showModal();
                });
            }else{

            }
        });
    }

    enterTab = (next) => (e) => {if (e.which === 13) document.getElementById(next).focus();}

    contenido = () => {
        const { selectedOption, title, user, pass1, pass2, } = this.state;

        const options = [
            { value: '1', label: 'Estudiante' },
            { value: '2', label: 'Profesor' },
        ];

        let help1 = (
            <Popover title="Tipo de usuario" id="u_type" className="fuente-monserrat">
                <strong style={{color:"#1f2f6e"}}>Importante: </strong>
                El tipo de usuario será verificado por <strong>Control de Estudios</strong>
            </Popover>
        )

        let help2 = (
            <Popover title="Correo Electrónico" id="email" className="fuente-monserrat">
                Introduce un <strong>Correo Electrónico</strong> válido. <br/>
                Ej: <strong style={{color:"#1f2f6e"}}>example@exampĺe.com</strong>
            </Popover>
        )

        let help3 = (
            <Popover title="Contraseña" id="pass" className="fuente-monserrat">
                Introduce una <strong>Contraseña segura</strong>
            </Popover>
        )

        return (
            <React.Fragment>
                <Row>
                    <Col md={3} align="right" className="fuente-monserrat">
                        Tipo de Usuario:
                    </Col>
                    <Col md={7}>
                        <Select
                            isSearchable ={false}
                            value={selectedOption}
                            onChange={this.handleChange}
                            options={options}
                            className="fuente-monserrat"
                        />
                    </Col>
                    <Col md={2} align="center">
                        <OverlayTrigger trigger="focus" placement="right" overlay={help1}>
                            <button className="btn btn-warning fuente-monserrat" style={{borderWidth:1}} title={title}><i className="fa fa-question-circle-o"></i></button>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row style={{marginTop:10}}>
                    <Col md={3} align="right" className="fuente-monserrat">
                        Correo Electrónico:
                    </Col>
                    <Col md={7}>
                        <div className={user.status}>
                            <input type="text" onChange={this.cambiaValorEmail("user")} value={this.state.user.text} onKeyPress={this.enterTab("pass1")} placeholder="Correo Electrónico" className="form-control"/>
                        </div>
                    </Col>
                    <Col md={2} align="center">
                        <OverlayTrigger trigger="focus" placement="right" overlay={help2}>
                            <button className="btn btn-warning fuente-monserrat" style={{borderWidth:1}} title={title}><i className="fa fa-question-circle-o"></i></button>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row style={{marginTop:10}}>
                    <Col md={10} align="right">
                        <Col md={5} align="right" className="fuente-monserrat">
                            Contraseña:
                        </Col>
                        <Col md={7} style={{paddingRight: 0,}}>
                            <div className={pass1.status}>
                                <input type="password" id="pass1" onChange={this.cambiaValor("pass1")} onKeyPress={this.enterTab("pass2")} placeholder="Ingresa una contraseña" className="form-control"/>
                            </div>
                        </Col>
                        <Col md={5} align="right" style={{marginTop:10}} className="fuente-monserrat">
                            Repite la Contraseña:
                        </Col>
                        <Col md={7} style={{marginTop:10, paddingRight: 0,}}>
                            <div className={pass2.status}>
                                <input type="password" id="pass2" onChange={this.cambiaValor("pass2")} onKeyPress={this.enterTab("register")} placeholder="Repite contraseña" className="form-control"/>
                            </div>
                        </Col>
                    </Col>

                    <Col md={2} align="center" style={{marginTop:30}}>
                        <OverlayTrigger trigger="focus" placement="right" overlay={help3}>
                            <button className="btn btn-warning fuente-monserrat" style={{borderWidth:1}} title={title}><i className="fa fa-question-circle-o"></i></button>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row style={{marginTop:20}}>
                    <Col md={8} className = "text-danger fuente-monserrat" style={{fontSize: 13, marginTop: 10}}>
                        ¿Problemas con esta ventana? Escribe a <strong>soporte@tad.com</strong>
                    </Col>
                    <Col md={4} align="right">
                        {this.botones()}
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    ayuda = () => {
        return (
            <React.Fragment>
                <Row>
                    <Col md={3} align="right" className="fuente-monserrat">
                        <strong>Paso 1</strong>
                    </Col>
                    <Col md={9} align="justify" className="fuente-monserrat">
                        Llena todos los campos para completar el registro. <strong>Importante:</strong> Debes ser un <span style={{color:"#1f2f6e"}}>Estudiante y/o Profesor</span> activo para registrarte
                    </Col>
                </Row>
                <Row className="custom-mt-20">
                    <Col md={3} align="right" className="fuente-monserrat">
                        <strong>Paso 2</strong>
                    </Col>
                    <Col md={9} align="justify" className="fuente-monserrat">
                        Luego de registrarte revisa tu correo para validar el registro
                    </Col>
                </Row>
                <Row className="custom-mt-20">
                    <Col md={3} align="right" className="fuente-monserrat">
                        <strong>Paso 3</strong>
                    </Col>
                    <Col md={9} align="justify" className="fuente-monserrat">
                        Completa los datos personales para culminar con el proceso de registro
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    showModal = () => {
        const { openW, tituloModal, contenidoModal, boton1Modal, boton2Modal } = this.state;
        return (
            <CustomModal
                isopen =  {openW}
                titulo = {<div className="text-primary">{tituloModal}</div>}
                contenido = {contenidoModal}
                boton1 = {boton1Modal}
                boton2 = {boton2Modal}
                funcion1 = {this.funcion1}/>
        );
    }

    titulo = () => (
        <Row>
            <Col md={3}>
                <img src={logo} alt="User" className="img img-responsive"
                        style={{height:"auto", width:35}}/>
            </Col>
            <Col md={9} align="right">
                <span className="fuente-monserrat">Regístrate</span>
                <div className="text-muted fuente-monserrat" style={{fontSize:12, marginTop:-10}}>Completa todos los campos para continuar</div>
            </Col>
            
        </Row>
    )

    render() {
        return (
            <React.Fragment>
                <div className="wrapper2">
                    <div className="wave one"></div>
                    <div className="wave dos"></div>
                    <div className="wave tres"></div>
                </div>
                <div className="login-content" style={{position:"fixed"}}>
                    <Row>
                        <Col md={1}></Col>
                        <Col md={10}>
                            <Col md={8}>
                                <div style={{/* boxShadow: "1px 1px 2px #000",  */borderRadius: "4px 4px",}}>
                                <CustomCard
                                    title={this.titulo()}
                                    color="#a80012"
                                    content={this.contenido()}
                                />
                                </div>
                            </Col>
                            <Col md={4}>
                                <CustomCard
                                    styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                    title={<span style={{color: "#fff"}} className="fuente-monserrat"><i className="pe-7s-help1"></i> Ayuda</span>}
                                    category={<span style={{color: "#fff"}} className="fuente-monserrat">Registro de Usuarios</span>}
                                    color="#a80012"
                                    content={this.ayuda()}
                                />
                            </Col>
                        </Col>
                        <Col md={1}></Col>
                    </Row>
                </div>
                <ToastContainer
                    position="bottom-right"
                    autoClose={3000}/>
                    {this.showModal()}
            </React.Fragment>
        );
    }
}
 
export default Register;


// WEBPACK FOOTER //
// ./src/site/Views/Register.jsx